// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyA4o_8jp29UJkxPkdXTkbM5ucvbZhiHec8",
    authDomain: "luizantoniodelivery.firebaseapp.com",
    databaseURL: "https://luizantoniodelivery.firebaseio.com",
    projectId: "luizantoniodelivery",
    storageBucket: "luizantoniodelivery.appspot.com",
    messagingSenderId: "168588835910",
    appId: "1:168588835910:web:38e33977229478aea91e47",
    measurementId: "G-023E67XFHJ"
  }
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
